import { TmcContextService } from './../../common/tmc-context.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { StructureNode } from './structure-node-selection.model';

@Component({
  selector: 'app-structure-node-selection',
  templateUrl: './structure-node-selection.component.html',
  styleUrls: ['./structure-node-selection.component.scss']
})
export class StructureNodeSelectionComponent implements OnInit, OnDestroy {

  _selectedNode: StructureNode;

  tmcContextSubscription: Subscription;

  disabled: boolean;

  @Input() set setDisabled(disabled: boolean) {
    this.disabled = disabled;
    if (this.disabled) {
      this.strcutureSelectionFormGroup.controls.structureNode.disable();
    } else {
      this.strcutureSelectionFormGroup.controls.structureNode.enable();
    }
  }

  @Input() set selectedNode(selectedNode: StructureNode) {
    this._selectedNode = selectedNode;
    this.setSelectedStructureNode(this._selectedNode);
  }

  @Output() selectedStructureChanged = new EventEmitter<StructureNode>();

  defaultNode = null;
  structureNodes = new Array<StructureNode>();

  strcutureSelectionFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService) {

    this.defaultNode = new StructureNode(translationService.translate('shared.structure-node-selection.option.all'), null, null);
    this.structureNodes.push(this.defaultNode);

    this.strcutureSelectionFormGroup.addControl('structureNode', new FormControl(null, []));

    this.strcutureSelectionFormGroup.valueChanges.subscribe(value => {
      if (this.strcutureSelectionFormGroup.dirty) {
        this.fireSelectionChanged();
      }
    });

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(yardConfiguration => {
      if (yardConfiguration != null) {
        for (const sg of yardConfiguration.stationGroups) {
          this.structureNodes.push(new StructureNode(sg.name, sg.id, null));
          for (const set of sg.stationSets) {
            this.structureNodes.push(new StructureNode(set.name, null, set.id));
          }
        }

        this.setSelectedStructureNode(this._selectedNode);
        this.fireSelectionChanged();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.tmcContextSubscription) {
      this.tmcContextSubscription.unsubscribe();
    }
  }

  private setSelectedStructureNode(selectedNode: StructureNode) {
    let restoredSelection = this.defaultNode;
    if (selectedNode != null) {
      for (const sn of this.structureNodes) {
        if (
          (selectedNode.stationGroupId != null && sn.stationGroupId === selectedNode.stationGroupId) ||
          (selectedNode.stationSetId != null && sn.stationSetId === selectedNode.stationSetId)) {
          restoredSelection = sn;
          break;
        }
      }
    }
    this.strcutureSelectionFormGroup.reset({ structureNode: restoredSelection });
  }

  private fireSelectionChanged() {
    this.selectedStructureChanged.next(
      this.strcutureSelectionFormGroup.controls.structureNode.value
    );
  }
}
